import { WorkspaceSpecificBannerProps } from "@components/banners/workspace-specific-banner/workspace-specific-banner-types";

/** Workspace specific banners */
export const WORKSPACE_SPECIFIC_BANNERS: WorkspaceSpecificBannerProps[] = [
  {
    title: "Payment Overdue",
    text: "Please contact administrator to avoid service interruption.",
    variant: "error",
    ids: [
      // Paste here the IDs of workspaces that need to see the payment overdue banner
    ],
  },
];
